import {useMutation, useQuery} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import {handleResponse, queryClient} from "../setup";
import Noti from "../../../view/components/general/noti";
import {Icd11Service} from "../../../services/requests/visit/icd11";

const useGetIcd11List = (params: any, modalName?: boolean) => {
  return useQuery({
    queryKey: ["getIcd11List", params],
    queryFn: ({ queryKey }: any) => {
      const [_, params] = queryKey;
      return Icd11Service.getIcd11List(params);
    },
    enabled: modalName ?? true
  });
}

const useGetIcd11 = () => {
  return useMutation({
    mutationFn: Icd11Service.getIcd11,
  })
}

const useAddIcd11 = ({
  onSuccess
}: {
  onSuccess: () => void
}) => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: Icd11Service.addIcd11,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getIcd11List"] })
          onSuccess();
        }
      })
    },
  })
}

const useDeleteIcd11 = ({
 onSuccess
}: {
  onSuccess: () => void
}) => {
  return useMutation({
    mutationFn: Icd11Service.deleteIcd11,
    onSuccess: (data: any) => {
      handleResponse({
        data,
        onSuccess: () => {
          Noti("success", data?.data?.msg)
          queryClient.invalidateQueries({ queryKey: ["getIcd11List"] })
          onSuccess();
        }
      })
    },
    onError: (error) => {
      Noti("error", error?.message)
    }
  })
}

export {
  useGetIcd11List,
  useGetIcd11,
  useAddIcd11,
  useDeleteIcd11
}
